import API_URLS from '../config/apiConfig';
import { apiGet, apiPost } from '../utils/apiUtils';
import type {
  SaveLottoPasswordRequest,
  SaveLottoPasswordResponse,
  RevealStorePasswordResponse,
  StorePasswordsResponse,
} from '../types/services/storePassword';

export type { StorePasswordServiceItem } from '../types/services/storePassword';

export type {
  SaveLottoPasswordRequest,
  SaveLottoPasswordResponse,
  RevealStorePasswordResponse,
  StorePasswordsResponse,
} from '../types/services/storePassword';

class StorePasswordService {
  async getStorePasswords(storeId: string): Promise<StorePasswordsResponse> {
    const data = await apiGet(API_URLS.GET_STORE_PASSWORDS(storeId));
    return data;
  }

  async saveLottoPassword(payload: SaveLottoPasswordRequest): Promise<SaveLottoPasswordResponse> {
    const data: SaveLottoPasswordResponse = await apiPost(API_URLS.SAVE_LOTTO_PASSWORD, payload);

    if (data && typeof data === 'object') {
      if (data.success === false) {
        throw new Error(data.message || data.detail || data.error || 'Failed to save lotto credentials');
      }

      if (typeof data.status === 'string' && data.status.toLowerCase() === 'error') {
        throw new Error(data.message || data.detail || data.error || 'Failed to save lotto credentials');
      }
    }

    return data;
  }

  async revealStorePassword(storeId: string, service: string): Promise<RevealStorePasswordResponse> {
    const data: RevealStorePasswordResponse = await apiGet(API_URLS.REVEAL_STORE_PASSWORD(storeId, service));
    return data;
  }
}

const storePasswordService = new StorePasswordService();
export default storePasswordService;
